<template>
  <div class="mb-1">
    <type-picker
      v-if="availableTypes.length > 0"
      :availableTypes="availableTypes"
      @type-pick="typePicked"
    ></type-picker>
    <div>
      <check-box
        id="include-open"
        name="include-open"
        label="Include Open?"
        :value="true"
        v-model="includeOpen"
      ></check-box>
      <check-box
        label="Include Closed?"
        id="include-closed"
        name="include-closed"
        v-model="includeClosed"
      ></check-box>
      <check-box
        label="Include Removed?"
        id="include-removed"
        name="include-removed"
        v-model="includeRemoved"
      ></check-box>
    </div>
    <div>
      <button
        class="btn btn-primary"
        type="button"
        :disabled="!resolveEnabled"
        @click="resovleClicked"
      >
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
import sharedoTypes from "@/services/sharedo/sharedoTypesService";
import TypePicker from "@/components/common/sharedo/TypePicker.vue";

const loadAvailableTypes = async function() {
  const rootTypes = this.query.query.widgetConfig.options.join(",");
  this.availableTypes = await sharedoTypes.getAll(rootTypes, false);
};

const typePicked = function(args) {
  this.selectedType = args.selectedType;
  this.typeSelector = args.typeSelector;
};

const resovleClicked = function() {
  const args = {};

  if (!this.includeOpen) {
    args.open = false;
  }

  if (this.includeClosed) {
    args.closed = true;
  }

  if (this.includeRemoved) {
    args.removed = true;
  }

  if (this.typeSelector === "path") {
    args.path = this.selectedType;
  } else {
    args.type = this.selectedType;
  }

  this.logDebug("Resolving descendents.", {
    arguments: args,
    fieldQueryName: this.query.name,
  });

  this.$emit("resolve", {
    arguments: args,
    fieldQueryName: this.query.name,
  });
};

export default {
  components: { TypePicker },
  props: {
    field: {
      required: true,
    },
  },
  data: function() {
    return {
      availableTypes: [],
      selectedType: null,
      typeSelector: "path",
      includeOpen: true,
      includeClosed: false,
      includeRemoved: false,
    };
  },
  computed: {
    query: function() {
      return this.field.value.queries.find(
        (q) => q.query.name === "sharedo.descendants"
      );
    },
    typeItems: function() {
      return this.availableTypes.map((t) => ({
        label: t.name,
        value: t.systemName,
      }));
    },
    resolveEnabled: function() {
      return !!this.selectedType;
    },
  },
  watch: {
    field: async function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        await this.loadAvailableTypes();
      }
    },
  },
  emits: ["resolve"],
  methods: {
    loadAvailableTypes,
    typePicked,
    resovleClicked,
  },
  mounted: async function() {
    await this.loadAvailableTypes();
  },
};
</script>
